import React from "react";
import NotSubscribed from "./NotSubscribed";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import ScheduleAppointment from "./ScheduleAppointment";
import api from "../../utils/api";
import "./Appointment.scss";
import { CONSTANTS } from "utils/constant";
import { setTimeZoneOffset, setDoctorSelectedData } from "store/slice/login-slice"; 
import Loader from "Components/Loader";
import Icons from "Common/Icons";
import { withTranslation , Trans} from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import utils from "utils";
class Appointment extends React.Component {
  _baseClassName = "schedule-appointment-container";
  constructor(props) {
    super(props);
    this.state = {
      user_details: this.props.user_details,
      slotData: [],
      slot_details: [],
      flag: false,
      subscription : {},
      selectedView : '',
      is_evaluated : "",
      current_offset_date_time: "",
      data:{},
      isLoading:true,
    };
  }

  getAppointmentView() {
    this.setState({isLoading:true})
    api
    .get_profile_status()
    .then((res) => {  
      let response = {data:{data:{}}};
      response.data.data = {...res.data.data};
      let result = "appointment"

      // let { is_plan_active='',is_plan_expired = '', plan_expiry_date = '', plan_expiry_type = '', plan_name = ''} = response.data?.data.care_plan || {};
      let activePlan=utils.getLatestPlan( response.data?.data.care_plans);
      let { is_plan_active='',is_plan_expired = '', plan_expiry_date = '', plan_expiry_type = '', plan_name = ''} = activePlan;
      localStorage.setItem("subscription", JSON.stringify({ is_plan_active,is_plan_expired , plan_expiry_date , plan_expiry_type , plan_name }))
      this.props.setTimeZoneOffset(response.data?.data?.time_zone?.time_zone_offset_in_min);

      // if(plan_name && !response.data?.data?.appointment.is_appointment_eligible) result =  "notCompleted";
      // else 
      // if(response.data?.data?.appointment.is_care_team_ticket_created)
      //   result="careTeamAssigned"
      this.setState({ selectedView: result,
        membership_type :  plan_name,
        current_offset_date_time: response.data?.data?.time_zone?.local_date_time,
        data:res.data.data, isLoading:false})
  })
}
  componentWillUnmount() {
    this.props.setDoctorSelectedData({
      appointmentStepper: false,
      doctorID: "",
      doctorSelectedData: {},
    });
  }    
  
  componentDidMount() {
    this.getAppointmentView();
  }
  render() {
    const { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    return(
    <> 
      {this.state.isLoading ? <Loader tgtLangST={tgtLangST}/> :<div className="appointment-wrapper">
        <div className="main-content">
            {(this.state.selectedView == "subscription" || this.state.selectedView == "notCompleted") && <NotSubscribed  membership_type={this.state.membership_type} show={this.state.selectedView == "notCompleted" ? true : false}/> || null}
            {this.state.selectedView == "appointment" && <ScheduleAppointment data={this.state.data} doctorID={this.props.doctorID || ""} doctorSelectedData={this.props.doctorSelectedData || {}} history={this.props.history} currentOffsetDateTime={this.state.current_offset_date_time} getAppointmentView={this.getAppointmentView.bind(this)} appointmentStepper={this.props.appointmentStepper || false}/> || null}
            {this.state.selectedView == "careTeamAssigned" && 
            <div className="main-content">
              <div className="phi-not-filled-content">
              <div><img className="center-img" src={Icons.info_blue}/></div>
                <div className="center-text care-team-is-assigned">{CONSTANTS.APPOINTMENT_CENTER_TEXT}</div>
              </div>
            </div>}
        </div>
      </div>
    }
  </>
  )
  }
}

const mapStateToProps = state => {
  return {
    user_details: state.loginReducer.user_details,
    doctorSelectedData: state.loginReducer.doctorSelectedData,
    doctorID : state.loginReducer.doctorID,
    appointmentStepper : state.loginReducer.appointmentStepper,
    includePrimeLang: state.loginReducer.includePrimeLang,
  }
}
const mapDispatchToProps = {setTimeZoneOffset, setDoctorSelectedData};
export default compose(withRouter,connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Appointment))